// Root mutations
import Vue from 'vue'
import _ from 'underscore'
import { forEach } from 'lodash'

export default {
  SET_SURVEY (state, survey) {
    state.survey = survey
  },

  LOGOUT() {
    localStorage.survey = null
  },

  POPULATE_SURVEY_AT_STATE(state) {
    state.survey = localStorage.getItem('survey')
  },

  RESPONSE (state, payload) {
    // _.extend(_.findWhere(state.survey.statement_surveys, { id: payload.statementId }), payload)
    let statement = _.findWhere(state.survey.statement_surveys, { id: payload.statementId })
    forEach(payload, (value, key) => Vue.set(statement, key, value))
    // _.extend does not update the application state, because adding new Object properties cannot be tracked, used Vue.set method sovles this
  },

  SECTION (state, payload) {
    state.pointers.section = payload
  },

  CAPABILITY (state, payload) {
    state.pointers.capability = payload
  },

  STATEMENT (state, payload) {
    state.pointers.statement = payload
  },

  UPDATE_RESPONSE (state, payload) {
    if (payload.response_index !== undefined){
      Vue.set(state.survey.statement_surveys[payload.statement_index].statement_responses.data,payload.response_index, payload.response)
    }else{
      state.survey.statement_surveys[payload.statement_index].statement_responses.data.push(payload.response)
    }
  },

  LOADING_MODAL_ACTIVE(state, payload) {
    state.loadingModalActive = payload
  },

  OPEN_ERRORS_MODAL(state, payload) {
    state.errors = assign({}, payload)
  },

  CLOSE_ERRORS_MODAL(state) {
    assign(state.errors, { content: [] })
  },

  CAN_DISPLAY_SECTION_RESULTS(state, payload) {
    state.canDisplaySectionResults = payload
  },

  PUSHER(state, payload) {
    state.pusher = payload
  }
}
